import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/authController";
import tire from "./modules/partnerTireController";
import partnerSpare from "./modules/partnerSpare";
import partnerJobs from "./modules/partnerJobs";
import partnerUsers from "./modules/partnerUsers";
import partnerOrders from "./modules/partnerOrders";
import partnerPurchaseOrder from "./modules/partnerPurchaseOrder";
import partnerDirectories from "./modules/partnerDirectories";
import carController from "./modules/carController";
import userCar from "./modules/userCar";
import adminTireController from "./modules/admin/adminTireController";
import adminSpareController from "./modules/admin/adminSpareController";
import adminController from "./modules/admin/adminController";
import categoryController from "./modules/categoryController";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth,
        tire,
        partnerSpare,
        partnerJobs,
        partnerUsers,
        partnerOrders,
        partnerPurchaseOrder,
        partnerDirectories,
        carController,
        userCar,
        adminTireController,
        adminSpareController,
        adminController,
        categoryController
    }
});